<template>
  <div class="dangerpage" v-show="showFace">
    <div class="modalBg"></div>
    <div class="modalpage">
      <div class="close" @click="close">
        <img class="guanbi" @click="close" src="@/assets/image/关闭.png" />
      </div>
      <div class="title">实人人像采集</div>
      <div class="tips">
        <div>1. 请确保本人人像采集清晰</div>
        <div>2. 人像五官区域应居中</div>
        <div>3. 确保采集人像免冠照片</div>
      </div>
      <div class="photo">
        <div style="margin-bottom: 20px">
          <img class="myPhoto" :src="userInfo.certificateHeadPhoto" />
          <div class="myPhotoText">我的照片</div>
        </div>
        <div>
          <div class="myPhoto">
            <video
              id="video"
              style="display: none"
              autoplay
              preload
              loop
              muted></video>
            <canvas
              id="snapshotCanvas"
              width="240"
              height="240"
              style="display: block"></canvas>
          </div>
          <div class="myPhotoText">我在学习</div>
        </div>
      </div>
      <div class="photoBtn" @click="takePicture" v-loading="loading">确定</div>
    </div>
  </div>
</template>

<script>
import { faceMatch } from "@/api/wkApi";
import { getUserInfo, upload } from "@/api/user";

export default {
  props: {
    classId: "",
    schoolClassId: "",
    classSectionId: "",
  },
  data() {
    return {
      loading: false,
      showFace: false,
      videoObj: null,
      snapshots: [],
      captureInterval: null,
      animationFrameId: null,
      userInfo: {},
      isUploadFaceImg: false,
    };
  },
  methods: {
    async handleFile(file) {
      console.log(file);
      let files = file.target.files[0];
      const res = await upload({ file: files, bizPath: this.bizPath });
    },
    async getUserInfo() {},
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    async faceMatch(files) {
      const filesRes = await upload({ file: files, bizPath: "face_match" });
      faceMatch({
        faceImg: filesRes.result,
        classId: this.classId,
        schoolClassId: this.schoolClassId,
        classSectionId: this.classSectionId,
      }).then((res) => {
        if (res.code == 200 && res.result && res.result.matchScore >= 0) {
          this.$message.success("人脸抓拍成功");
          this.$emit("success", { code: 200, msg: "人脸抓拍成功" });
          this.showFace = false;
        } else {
          this.$message.warning("人脸比对失败, 请调整好摄像头重新拍摄");
        }
        this.loading = false;
        this.stopCapture();
      });
    },
    startCamera() {
      this.videoObj = document.getElementById("video");
      const constraints = {
        video: { width: 150, height: 150, transform: "scaleX(-1)" },
        audio: false,
      };
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            this.videoObj.srcObject = stream;
            this.videoObj.onloadedmetadata = () => {
              this.videoObj.play();
              this.startCapture();
            };
          })
          .catch((err) => {
            this.$confirm(
              "请使用 chrome 和 edge 浏览器, 并授权打开摄像头",
              "警告",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).finally(() => {
              this.$emit("close");
              this.close();
            });
          });
      } else {
        this.$confirm(
          "请使用 chrome 和 edge 浏览器, 并授权打开摄像头",
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).finally(() => {
          this.$emit("close");
          this.close();
        });
      }
    },

    startCapture() {
      const canvas = document.getElementById("snapshotCanvas");
      const context = canvas.getContext("2d");
      const updateCanvas = () => {
        context.drawImage(this.videoObj, 0, 0, canvas.width, canvas.height);
        this.animationFrameId = requestAnimationFrame(updateCanvas);
      };
      updateCanvas();
    },
    // 点击拍摄, 调用函数
    takePicture() {
      this.loading = true;
      const canvas = document.getElementById("snapshotCanvas");
      // 获取图像数据并转换为 File 对象
      const imgData = canvas.toDataURL("image/png");
      this.dataURLtoFile(imgData, `snapshot-${Date.now()}.png`).then((file) => {
        this.faceMatch(file);
      });
    },
    close() {
      this.stopCapture();
    },
    // 上报人脸图片
    async uploadFaceImg() {
      this.showFace = true;
      let res = await getUserInfo();
      if (res.code == 200 && res.data) {
        if (res.data.certificateHeadPhoto) {
          this.userInfo = res.data;
          this.startCamera();
        } else {
          this.$message.warning("请前往个人中心-完善信息, 完善头像信息");
        }
      } else {
        this.userInfo = {};
      }
    },
    dataURLtoFile(dataURL, filename) {
      return fetch(dataURL)
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], filename, { type: "image/png" });
        });
    },
    stopCapture() {
      this.showFace = false;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      if (this.videoObj && this.videoObj.srcObject) {
        this.videoObj.srcObject.getTracks().forEach((track) => track.stop());
      }
    },
  },
  beforeDestroy() {
    this.stopCapture();
  },
};
</script>

<style lang="scss" scoped>
.dangerpage {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  .modalBg {
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .modalpage {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 5px;
    padding: 20px 60px;
    width: 550px;
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .tips {
      font-size: 14px;
      color: #9b9b9b;
      margin-bottom: 10px;
    }
  }
  .photo {
    display: flex;
    justify-content: space-between;
  }
  .myPhoto {
    width: 240px;
    height: 240px;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 2px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .myPhotoText {
    font-weight: normal;
    font-size: 20px;
    color: #4a4a4a;
    line-height: 28px;
    font-style: normal;
    text-align: center;
  }
  .photoBtn {
    margin: 0 auto;
    cursor: pointer;
    width: 200px;
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%) !important;
    text-align: center;
    color: #fff;
  }
}
</style>
